
import { Message } from '@/lib/session';
import { MessageBubble } from './MessageBubble';
import { shouldShowDateSeparator, formatDateSeparator } from '@/lib/utils';

interface ChatMessagesProps {
  messages: Message[];
  isLoading: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  isNewMessage?: boolean;
}

export const ChatMessages = ({ messages, isLoading, messagesEndRef, isNewMessage }: ChatMessagesProps) => {
  return (
    <div className="chat-container flex-1 overflow-y-auto">
      {messages.length === 0 ? (
        <div className="text-center text-muted-foreground py-8">
          Start a conversation by sending a message below
        </div>
      ) : (
        messages.map((message, index) => (
          <div key={index}>
            {message.timestamp && index > 0 && shouldShowDateSeparator(message, messages[index - 1]) && (
              <div className="flex items-center justify-center my-6">
                <div className="text-xs font-medium text-gray-500 bg-gray-100/50 px-3 py-1 rounded-full">
                  {formatDateSeparator(message.timestamp)}
                </div>
              </div>
            )}
            <MessageBubble 
              message={message} 
              isLoading={isLoading && index === messages.length - 1 && message.role === 'assistant'} 
              isNewMessage={isNewMessage}
            />
          </div>
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};
